module.exports = __webpack_public_path__ + "static/inline-edit-do-3c9707252091181a5a2075c9e2cbff9c.png";